module.exports = __webpack_public_path__ + "images/marketing/peeps/dan_bradley.jpg";